import { AxiosRequestConfig } from 'axios';
import { APIPromise, APIResponse, requestPromiseTypeWrapper } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { BaseDatasetDTO } from "./model/dataset/BaseDatasetDTO";
import { DatasetInfo } from "./model/dataset/DatasetInfo";
import { DatasetCategoryDTO } from "./model/datset/DatasetCategoryDTO";



const promise = requestPromiseTypeWrapper;

class DatasetsApiDefinition extends ApiDefinition {

    constructor() {
        super("/datasets")
    }

    async getDatasetCategories(): APIPromise<DatasetCategoryDTO[]> {
        try {
            const {data} = await this.httpClient.get(`${this.apiScopeUrl}/categories`);
            const obj = data.map((it: Partial<DatasetCategoryDTO>) => new DatasetCategoryDTO(it))
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

    async getBaseDataset(identifier: string | undefined | null): APIPromise<BaseDatasetDTO | null> {
        if (!identifier) {
            return {data: null};
        }

        try {
            const {data} = await this.httpClient.get(`${this.apiScopeUrl}/${identifier}`);
            const obj = new BaseDatasetDTO(data)
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

  async queryDatasets(query?: string | null, limit?: number | null, identifiers?: string[] | null): APIPromise<DatasetInfo[]> {
    const params = {
      query: query || null,
      limit,
      identifiers: identifiers?.join(",") || undefined,
    };

        try {
            const {data} = await this.httpClient.get(`${this.apiScopeUrl}/search`, {params});
            const obj = data.map((it: any) => new DatasetInfo(it))
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

    async getDatasetInfo(identifier: string | null): APIPromise<DatasetInfo> {
        if(!identifier) return {data: undefined};
        return promise(this.httpClient.get(`${this.apiScopeUrl}/search`, {params: {identifiers: identifier}}), (data: any) => {
            return new DatasetInfo(data[0]);
        });
    }

    async getDatasetsInfo(identifiers: Array<string | null>): APIPromise<Array<DatasetInfo>> {
        const ids = identifiers.filter(e => e!=null)
        if(!ids) return {data: undefined};

        return promise(this.httpClient.get(`${this.apiScopeUrl}/search`, {params: {identifiers: ids.join(",")}}), (data: any) => {
            return data.map((item:any) => new DatasetInfo(item))
        });
    }

    async getPaginatedDatasetsList(query?: string | null, page?: number | null, limit?: number | null, identifiers?: string | null): APIPromise<DatasetInfo[]> {
        return promise(
          this.httpClient.get(`${this.apiScopeUrl}/search`, {
            params: {
              query,
              page,
              limit,
              identifiers,
              allowEmptyQuery: true,
            },
          }),
          (data: any) => data.map((d: Partial<DatasetInfo>) => new DatasetInfo(d))
        );
    }

    async getDatasetsCount(): APIPromise<number> {
    return this.get("count");
    }

    async putUpdateDatasetInfo(datasetInfo: BaseDatasetDTO, fullUpdate?: boolean): APIPromise<BaseDatasetDTO> {
        const config: AxiosRequestConfig = {
            params: {
                fullUpdate
            }
        };
    
        return this.put(`${datasetInfo.identifier}`, datasetInfo, config);
    }

    async getDefaultDatasetCategory():APIPromise<DatasetCategoryDTO> {
        return this.get("categories/default")
    }

    async createNewCategorizedDataset(data: Partial<BaseDatasetDTO>): APIPromise<BaseDatasetDTO> {
        return this.post("create-categorized", data)
    }

    async deleteDataset(identifier: string): APIPromise<any> {
        return this.delete(`${identifier}/soft-delete`);
    }

    async getDatasetsByTags(categoryId: number | undefined, tags: string): APIPromise<DatasetInfo[]> {
        const datasetsByTags: APIResponse<DatasetInfo[]> = await this.get(`byTags?categoryId=${categoryId}&tags=${tags}`);
        const filteredDatasetsByTags = datasetsByTags.data?.filter((item: DatasetInfo) => !item.deleted) ?? [];
        return {
            ...datasetsByTags,
            data: filteredDatasetsByTags
        };
    }  
}

export const DatasetsApi = new DatasetsApiDefinition();
